import { LayoutRecord } from "./LayoutRecord";

/**
 * Temporary layout ID used for temporary workspace state
 */
export const TEMPORARY_LAYOUT_ID = "initial-workspace-layout";

/**
 * Returns true if the given layout is the temporary workspace state.
 */
export function isTemporaryLayout(layout: LayoutRecord): boolean {
  return layout.layout_id === TEMPORARY_LAYOUT_ID;
}
